import { FeedingCommandCenter } from "@/features/feeding-command-center";

export function FeedingPage() {
  return <FeedingCommandCenter />;
}
